<template>
    <div class="B2BCoop bg-white dark:bg-surface-card">
        <div class="container flex flex-col items-center lg:items-start">
            <CText variant="muted">Úspešne s nami spolupracujú</CText>

            <div class="mt-6 grid w-full grid-cols-2 justify-center gap-5 sm:flex sm:flex-row sm:flex-wrap">
                <img
                    v-for="(img, index) in images"
                    :key="index"
                    :alt="img"
                    class="mx-auto object-contain sm:mx-0"
                    :class="type == 'gov' ? 'w-32 h-20' : 'w-24 h-15'"
                    :src="`/images/coop/${img}`"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import { B2BType } from '#shared/types/B2B'
import CText from '@/components/ui/CText.vue'
import { computed } from 'vue'

const IMAGES = {
    [B2BType.DEFAULT]: [
        'tatra-banka.png',
        'miiri.png',
        'nexteria.png',
        'ibm.png',
        'mhsr.png',
        'bloomreach.png',
        'nsp.png',
        'tis.png'
    ],

    [B2BType.GOV]: ['miiri.png', 'mhsr.png', 'tis.png'],
    [B2BType.NGO]: [
        'sytev.png',
        'chut-zit.png',
        'nexteria.png',
        'mareena.png',
        'pontis.png',
        'sda.png',
        'dofe.png',
        'tis.png'
    ]
} as const

const props = defineProps({
    type: {
        type: String as PropType<B2BType>,
        default: B2BType.DEFAULT
    }
})

const images = computed(() => IMAGES[props.type])
</script>
